import { CommonModule } from "@angular/common";
import {
  Component,
  Input,
  OnChanges,
  OnInit
} from "@angular/core";
import {
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";

import { TranslateModule } from "@ngx-translate/core";
import { SharedModule } from "../../shared.module";
import { PaymentStatusEnum } from "src/app/enums/payment-status.enum";
import { IPayment, PaymentConditionItem } from "src/app/services/model/get-trip-data.model";

@Component({
  selector: "app-payments-calendar",
  templateUrl: "./payments-calendar.component.html",
  styleUrls: ["./payments-calendar.component.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, SharedModule],

})
export class PaymentsCalendarComponent implements OnInit, OnChanges {


  @Input() payments: PaymentConditionItem[] = [];
  public isCollapsed = false;

  @Input() expanded: boolean = false;

  public get showToggleIcon(): boolean {
    return true; 
  }

  ngOnInit(): void {
    this.isCollapsed = !this.expanded;
  }

  ngOnChanges() {
  }

  public toggleCollapsed(): void {
    if (!this.showToggleIcon) {
      return;
    }

    this.isCollapsed = !this.isCollapsed;
  }

  public onHeaderKeydown(event: KeyboardEvent): void {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.toggleCollapsed();
    }
  }

  public getStatusClass(status: PaymentStatusEnum) {
    return PaymentStatusEnum[status]?.toLowerCase() || status?.toString() || '';
  }
}